import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { FormattedMessage, intlShape } from "react-intl";
import { Button, Loader, Toolbar, ToolbarSection } from "cxa-components";
import { PrintIcon } from "cxa-icons";
import AccountsList from "components/claim/AccountsList";
import AccountUtilization from "./widgets/AccountUtilization";
import PlanHeader from "./widgets/PlanHeader";
import messages from "components/messagesDescription";
import AccountSummaries from "./widgets/AccountSummaries";
import SOAPopup from "./widgets/SOAPopup";

const { printTextDescription } = messages;
class AccountStatement extends Component {
  constructor() {
    super();
    this.state = { isPopupOpen: false };
    this.showPopup = this.showPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
  }

  showPopup(e) {
    e.preventDefault();
    this.setState({ isPopupOpen: true });
  }

  closePopup() {
    this.setState({ isPopupOpen: false });
  }

  componentDidMount() {
    const { loadAccounts, benefitPeriod, benefitPeriodEnd } = this.props;

    loadAccounts(benefitPeriod, benefitPeriodEnd);
  }

  render() {
    const { account, user, rows, columns, intl, isFetched, pageFields, uiConfigs } = this.props;
    const { currency, nameForEmployee } = account;
    const accountStatement = `${nameForEmployee} Statement`;

    if (!isFetched) {
      return <Loader />;
    }

    return (
      <div>
        <h1>
          <FormattedMessage id={accountStatement} defaultMessage={accountStatement} />
        </h1>

        <Toolbar>
          <ToolbarSection />

          <ToolbarSection>
            <Button className="apl-no-print" type="button" onClick={window.print}>
              <PrintIcon />
              {intl.formatMessage(printTextDescription)}
            </Button>
          </ToolbarSection>
        </Toolbar>

        <PlanHeader intl={intl} user={user} account={account} pageFields={pageFields} />

        {!uiConfigs || !uiConfigs.isEnabled ? (
          <AccountUtilization intl={intl} account={account} uiConfigs={uiConfigs} />
        ) : (
          <AccountSummaries intl={intl} account={account} uiConfigs={uiConfigs} />
        )}
        <div dangerouslySetInnerHTML={{ __html: account.soaRemarks }} />
        {account.soaPopUpLinkText && (
          <Fragment>
            <Link
              to="/"
              onClick={this.showPopup}

            >
              {account.soaPopUpLinkText}
            </Link>
            <SOAPopup
              isOpen={this.state.isPopupOpen}
              closePopup={this.closePopup}
              planYear={this.props.benefitPeriod}
              accountType={account.accountType}
              currency={currency}
            />
          </Fragment>
        )}
        <div style={{ marginTop: "20px", marginBottom: "20px" }}/>
        <AccountsList currency={currency} rows={rows} columns={columns} />
      </div>
    );
  }
}

AccountStatement.propTypes = {
  loadAccounts: PropTypes.func.isRequired,
  benefitPeriod: PropTypes.string,
  benefitPeriodEnd: PropTypes.string,
  error: PropTypes.object,
  account: PropTypes.object,
  isFetched: PropTypes.bool,
  user: PropTypes.object,
  intl: intlShape.isRequired,
  pageFields: PropTypes.array,
  columns: PropTypes.array,
  rows: PropTypes.array,
  uiConfigs: PropTypes.object,
};

export default AccountStatement;



// WEBPACK FOOTER //
// ./components/claim/ClaimAccountStatement.jsx